module.exports = __webpack_public_path__ + "static/media/pradip.10c6c8e3.jpeg";